
import TestInstructionsStepSixComponent from '@/components/Shared/RegisterTest/TestInstructionsStepSix/TestInstructionsStepSixComponent';
export default TestInstructionsStepSixComponent;
